import { render, staticRenderFns } from "./ScreenshotMaker.vue?vue&type=template&id=481802c5&scoped=true&"
import script from "./ScreenshotMaker.vue?vue&type=script&lang=js&"
export * from "./ScreenshotMaker.vue?vue&type=script&lang=js&"
import style0 from "./ScreenshotMaker.vue?vue&type=style&index=0&id=481802c5&scoped=true&lang=scss&"
import style1 from "./ScreenshotMaker.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481802c5",
  null
  
)

export default component.exports